export const IStockControl = {
  item_id: 7,
  qty: '1.100',
  store_id: 56,
  location_id: 2,
  location_name: 'location 1',
  item_name: 'Mozzarella',
  category_name: 'First Cat',
  unit_name: 'Kilogram',
  min_alert_qty: '0.000',
  plu: '',
  stock_value: 0,
}

export const IAdjustmentInfo = {
  inventory_unit: 1,
  inventory_unit_str: 'Kilogram',
  colour: '',
  current_stock_value: 0,
  current_stock_level: '0',
  current_unit_value: 0,
}
